import React, {Component} from "react";
import { Menu} from "antd";
import { withRouter } from 'react-router';

import './index.less';
import {reqCategory} from "../../api";

const { SubMenu } = Menu;

/**
 * 技能训练、案例学习的导航路由组件
 */
export class LeftNav extends Component {

    state = {
        list:[],
        openKeys: ['sub0'],
        cid:[3]
    };

    rootSubmenuKeys = ['sub0', 'sub1'];

    onOpenChange = openKeys => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys });
            sessionStorage.setItem("openKeys",openKeys);
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
            sessionStorage.setItem("openKeys",latestOpenKey ? [latestOpenKey] : []);
        }
    };

    selectChange=(e) => {
        sessionStorage.setItem("cid",e.key);
        this.setState({
            cid : [e.key]
        });
        this.props.history.push("/skill");
    };

    componentDidMount = async() => {
        let cid = sessionStorage.getItem("cid");
        let openKeys = sessionStorage.getItem("openKeys");
        const result = await reqCategory("SKILL");
        this.setState({
            list:result.data.rows,
            cid : cid===null?['3']:[cid],
            openKeys:openKeys?[openKeys]:['sub0']
        });
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render(){

        const {list} = this.state;

        return (
            <div className="left_nav">
                <Menu onClick={this.selectChange} selectedKeys={this.state.cid} openKeys={this.state.openKeys}
                      onOpenChange={this.onOpenChange} mode="inline">
                    {
                        list && list.map(function(item,index){
                                return (
                                    <SubMenu id={"sub"+index}  key={"sub"+index} title={<span>{item.name}</span>}>
                                        {
                                            item.subs && item.subs.map(function(sub,number){
                                                return (
                                                    <Menu.Item key={sub.id} >{sub.name}</Menu.Item>
                                                );
                                            })
                                        }
                                    </SubMenu>
                                );
                            }
                        )
                    }
                </Menu>
            </div>
        )
    }
}

export default withRouter(LeftNav);